import type { CandidateIdentityStorage } from "./storage.types";
export const CANDIDATE_IDENTITY_STORAGE_KEY = "candidate-profile-identity";
export const LEGACY_JOB_ALERT_STORAGE_KEY =
  "public-job-alert-subscription-draft";

export const EMPTY_IDENTITY: CandidateIdentityStorage = {
  externalId: null,
  resumePersonalized: false,
  candidatePreferences: null,
};
